import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import TabsMenu from "../../components/TabsMenu";
import Loader from "../../components/Loader";
import {API, processApiResponse} from "../../services/HttpHandler";
/*
import CurrentAttentionDetails from "../../components/CurrentAttentionDetails";
import AttentionDetails from "../../components/AttentionDetails";
import CircularProgress from "../../components/CircularProgress";
*/
import "./style.scss";
import {useSelector, useDispatch} from "react-redux";
import {getFirebase} from "../../services/firebaseclient";
import {useNavigate} from "react-router-dom";
import absent_img from "../../images/absent.png";
import done_img from "../../images/done.png";
import {getCustomerSlotDetails} from "../../services/SessionStorage";
import TokenCard from "../../components/TokenCard";
import "../../components/Loader/style.scss";
import BlockBtn from "../../components/BlockBtn";
import config from "config";

// export const dataDashboard = (data) => {
//   if (window && window.s) {
//     for (const [key, value] of data) {
//       window.s[`${key}`] = `${value}`;
//     }
//     window.s.tl();
//   }
// };
const CurrentAttention = () => {
  const dispatch = useDispatch();
  const shiftsCalled = useSelector((state) => {
    return state.shiftsCalled;
  });
  const syncShiftsCalled = (payload) => {
    return {
      type: "SYNC_SHIFT_CALLED",
      payload,
    };
  };
  const [loading, setLoading] = useState(false);
  const {t} = useTranslation();
  const navigate = useNavigate();
  const customerSlotDetails = useRef(getCustomerSlotDetails());
  const [tokenAvailable, setTokenAvailable] = useState("");
  const [currentTokenStatus, setCurrentTokenStatus] = useState("");
  const [peopleBeforeThisToken, setPeopleBeforeThisToken] = useState(0);
  const sessionCurrentShiftDetail = customerSlotDetails.current.turneroDetails;
  const sessionSelectedStoreID = sessionCurrentShiftDetail.storeId;
  const selectedQueue =
    customerSlotDetails.current.turneroDetails.serviceTypeId;
  const [error, setError] = useState("");
  const attentionList = useRef([]);
  const currentAttentionFirstItem = useRef({});
  const nowMyTurn = useRef(false);

  useEffect(() => {
    /*
    const currentAttentionUrl = config.endPoints.currentAttention;
    const storeIdPlaceholder = /storeIdPlaceholder/gi;
    const url = currentAttentionUrl.replace(
      storeIdPlaceholder,
      sessionSelectedStoreID
    );

    try {
      setLoading(true);
      API.get(url)
        .then(processApiResponse)
        .then((resp) => {
          //const selectedCurrentAttention = resp.filter((s)=>{s.serviceTypeId===selectedQueue});
          //setCurrentAttention(selectedCurrentAttention);
          setCurrentAttention(resp);
        });
      setLoading(false);
    } catch (error) {
      setError("error occured");
      setLoading(false);
    } finally {
    }

     <CurrentAttentionDetails
            currentAttentionDetails={currentAttentionList}
            selectedQueue={selectedQueue}
          />
    */
  }, [sessionSelectedStoreID]);

  useEffect(() => {
    const postdata = {};
    try {
      API.post(config.endPoints.firebasetoken, postdata)
        .then(processApiResponse)
        .then((response) => {
          setTokenAvailable(response);
        });
    } catch (error) {
      setError(error?.message);
    } finally {
    }
  }, []);

  useEffect(() => {
    async function fetchData() {
      const turneroDetails = sessionCurrentShiftDetail;
      const storeId = turneroDetails.storeId;
      const serviceTypeId = turneroDetails.serviceTypeId;
      try {
        if (tokenAvailable && tokenAvailable !== "") {
          const firebaseInstance = await getFirebase(tokenAvailable.toString());
          firebaseInstance
            .database()
            .ref("/" + storeId + "/serviceTypes/" + serviceTypeId + "/")
            .once("value")
            .then((snapshot) => {
              const data = snapshot.val();
              if (data && data?.shiftsCalled) {
                dispatch(syncShiftsCalled(data.shiftsCalled));
                firebaseInstance
                  .database()
                  .ref(
                    "/" +
                      storeId +
                      "/serviceTypes/" +
                      serviceTypeId +
                      "/shiftsCalled/"
                  )
                  .on("value", (snapshot) => {
                    const data = snapshot.val();
                    if (data) {
                      dispatch(syncShiftsCalled(data));
                    }
                  });
              }
            });
        }
      } catch (error) {
      } finally {
      }
    }
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, tokenAvailable]);
  // Test Binu Paul

  const handleNewTurnero = () => {
    // const datamap = new Map();
    // datamap.set("events", "event9=1");
    // dataDashboard(datamap);
    navigate("/customer/selectTurneroStoreAndType");
  };

  const firebaseInstance = async (fbToken) => {
    const instance = await getFirebase(fbToken);
    return instance.database();
  };

  const initializeFirebaseAndTokenStatus = async (fbToken) => {
    const fi = await firebaseInstance(fbToken.toString());
    fi.ref(
      "/" +
        sessionCurrentShiftDetail.storeId +
        "/serviceTypes/" +
        sessionCurrentShiftDetail.serviceTypeId +
        "/tokensInQueue"
    ).on("value", (snapshot) => {
      const data = snapshot.val();
      if (data && data.length > 0) {
        const index = data.indexOf(sessionCurrentShiftDetail.tokenNumber);
        if (index > -1) {
          setPeopleBeforeThisToken(index);
        } else {
          setPeopleBeforeThisToken(0);
        }
      } else {
        setPeopleBeforeThisToken(0);
      }
    });
    const fiObject = await firebaseInstance(fbToken.toString());
    fiObject
      .ref(
        "/" +
          sessionCurrentShiftDetail.storeId +
          "/tokens/" +
          sessionCurrentShiftDetail.bookingId +
          "/status"
      )
      .on("value", (snapshot) => {
        const data = snapshot.val();
        if (data) {
          setCurrentTokenStatus(data);
        }
      });
  };

  useEffect(() => {
    if (tokenAvailable && tokenAvailable.length > 0)
      initializeFirebaseAndTokenStatus(tokenAvailable);
  }, [tokenAvailable]);

  if (shiftsCalled) {
    let rows = [];
    nowMyTurn.current = false;
    const keys = Object.keys(shiftsCalled);
    keys.sort((a, b) => {
      let fb = a,
        fa = b;

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
    keys.map((key) => {
      const tokenDetail = shiftsCalled[key];
      const tempObj = {
        moduleNumber: tokenDetail.moduleNumber,
        tokenNumber: tokenDetail.tokenNumber,
        status: tokenDetail.status,
      };
      rows.push(tempObj);
    });
    nowMyTurn.current = rows.some((data) => {
      return (
        data.tokenNumber === sessionCurrentShiftDetail.tokenNumber &&
        data.status === "IN_ATTENTION"
      );
    });
    rows.sort((a, b) =>
      a.attentionStartTime > b.attentionStartTime
        ? 1
        : b.attentionStartTime > a.attentionStartTime
        ? -1
        : 0
    );

    const fullList = rows.filter((x) => {
      return x.status === "IN_ATTENTION";
    });
    currentAttentionFirstItem.current =
      fullList && fullList.length > 0 ? fullList[0] : {};

    attentionList.current = rows;
  }

  const handleGoBack = () => {
    navigate("/customer/displayTurnero");
  };

  const renderTokenCard = () => {
    return (
      <TokenCard
        token={sessionCurrentShiftDetail.tokenNumber}
        serviceType={sessionCurrentShiftDetail.serviceType}
        parentComponent={"BookShift"}
        storeName={sessionCurrentShiftDetail.storeName}
        peopleBeforeThisToken={peopleBeforeThisToken}
        storeDetails={sessionCurrentShiftDetail}
        bookingTime={sessionCurrentShiftDetail.bookingTime}
      />
    );
  };

  const renderStatusDone = () => {
    return (
      <div className="status-container">
        <img className="status-done-img" src={done_img} alt="done_img" />
        <p className="status-title">{t("tokenStatusDone.title")}</p>
        <p className="status-description">{t("tokenStatusDone.description")}</p>
      </div>
    );
  };

  const renderStatusAbsent = () => {
    return (
      <div className="status-container">
        <img className="status-absent-img" src={absent_img} alt="absent_img" />
        <p className="status-title">{t("tokenStatusAbsent.title")}</p>
        <p className="status-description">
          {t("tokenStatusAbsent.description")}
        </p>
      </div>
    );
  };

  return loading ? (
    <div className="loader-container">
      <Loader />
    </div>
  ) : (
    <>
      <TabsMenu path="displayTurnero" />
      <div className="currentAttention-main-container">
        {!error ? (
          <div className="currentAttention-viewArea">
            {currentTokenStatus === "DONE"
              ? renderStatusDone()
              : currentTokenStatus === "ABSENT"
              ? renderStatusAbsent()
              : renderTokenCard()}
            <div className="displayTurnero-footer">
              <BlockBtn
                className="displayTurnero-button"
                name={t("book.shift")}
                handleClick={handleNewTurnero}
                disabled={false}
              />
            </div>
          </div>
        ) : (
          <div className="booking-error">{error}</div>
        )}
      </div>
    </>
  );
};

export default CurrentAttention;
